<template>
    <div class="wgCalcRightCol">
        <slot>

        </slot>

    </div>
</template>
<script>
export default {
    name: 'RightColumn'
}
</script>
<style lang="scss">
.wgCalc{
    &RightCol{
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 2rem;

    }
}
</style>
